module.exports = __webpack_public_path__ + "assets/img/gallery.69a1b91b.jpg";